// extracted by mini-css-extract-plugin
module.exports = {"benefits":"E_benefits__ihQrv"};